import * as React from "react";
import { createRoot } from "react-dom/client";
import { LoginPage } from "./LoginPage";

/* global document, Office, module, require */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(<LoginPage />);
});
